module.exports = __webpack_public_path__ + "static/media/Customer_Engagement.6394ad3e.png";